import React from "react";
import { IconType } from "react-icons";

import classes from "./IconButton.module.sass";

type Props = {
  onClick: () => void;
  icon: IconType;
  alt: string;
  display?: boolean;
  disabled?: boolean;
  small?: boolean;
  active?: boolean;
};

export const IconButton: React.FC<Props> = ({
  onClick,
  icon: IconComponent,
  alt,
  display = true,
  disabled,
  small,
  active,
}) => {
  if (!display) return null;

  return (
    <button
      className={`${small ? classes.ContainerSmall : classes.Container}`}
      data-active={active ? "true" : undefined}
      onClick={(e) => {
        onClick();
        e.stopPropagation();
      }}
      disabled={disabled}
      aria-label={alt}
      title={alt}
      type="button"
    >
      <IconComponent className={classes.Icon} />
    </button>
  );
};
